import { FundingRoundsData } from '../types/funding';

interface FundingRoundsTableProps {
  data: FundingRoundsData;
}

export default function FundingRoundsTable({ data }: FundingRoundsTableProps) {
  const formatDollar = (value: number | null, position?: number, unit?: string) => {
    return value === null ? '-' : position
      ? `$${Number(value/position).toFixed(2)}${unit || ''}`
      : `$${Number(value).toFixed(2)}${unit || ''}`;
  };

  const formatAmountDollar = (value: number | null) => {
    if (value === null) {
      return '-';
    } else {
      const u = Number(value/1e6) < 100 ? 'M' : 'B';
      const p = u === 'B' ? 1e9 : 1e6;
      return `$${Number(value/p).toFixed(2)}${u}`;
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <div className="w-full overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="">
          <tr className="text-xs sm:text-sm md:text-base lg:text-lg pt-3 pb-3 overflow-hidden text-ellipsis whitespace-nowrap font-medium text-white">
            <th className="px-2 sm:px-4 md:px-6 py-2 sm:py-4 bg-[#444648] text-center border border-gray-800 rounded-tl-md sm:rounded-tl-lg md:rounded-tl-xl">
              Fund
            </th>
            <th className="px-2 sm:px-4 md:px-6 py-2 sm:py-4 bg-[#444648] text-center border border-gray-800">
              Date
            </th>
            <th className="px-2 sm:px-4 md:px-6 py-2 sm:py-4 bg-[#444648] text-center border border-gray-800">
              Amount
            </th>
            <th className="px-2 sm:px-4 md:px-6 py-2 sm:py-4 bg-[#444648] text-center border border-gray-800">
              Issue Price
            </th>
            <th className="px-2 sm:px-4 md:px-6 py-2 sm:py-4 bg-[#444648] text-center border border-gray-800 rounded-tr-md sm:rounded-tr-lg md:rounded-tr-xl">
              Valuation
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {data.map((round) => (
            <tr key={round.id} className="hover:bg-[#333434]">
              <td className="px-2 sm:px-4 md:px-6 py-1 sm:py-2 whitespace-nowrap border border-gray-800 text-left text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px]">
                {round.roundName}
              </td>
              <td className="px-2 sm:px-4 md:px-6 py-1 sm:py-2 whitespace-nowrap border border-gray-800 text-center text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px]">
                {formatDate(round.date)}
              </td>
              <td className="px-2 sm:px-4 md:px-6 py-1 sm:py-2 whitespace-nowrap border border-gray-800 text-left text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px]">
                {formatAmountDollar(round.amount)}
              </td>
              <td className="px-2 sm:px-4 md:px-6 py-1 sm:py-2 whitespace-nowrap border border-gray-800 text-left text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px]">
                {formatDollar(round.stockPrice)}
              </td>
              <td className="px-2 sm:px-4 md:px-6 py-1 sm:py-2 whitespace-nowrap border border-gray-800 text-left text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px]">
                {formatDollar(round.valuation,1e9,'B')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
